import { GREEN_COLOR, ORANGE_COLOR, RED_COLOR } from 'src/resources/constantsCodes/constants';
import { colors } from 'src/themes/default';

const getStatusColor = (color?: string) => {
    switch (color) {
        case RED_COLOR:
            return colors.alert_O;
        case GREEN_COLOR:
            return colors.accent_O;
        case ORANGE_COLOR:
            return colors.alert_OR;
        default:
            return colors.text_T0;
    }
};

export default getStatusColor;
